const allowed = true;

const router = [
  {
    name: "login",
    path: "/login",
    meta: {
      guarded: false
    },
    component: () => import("@/views/auth/Login")
  },
  {
    name: "escolherperfil",
    path: "/escolher-perfil",
    meta: {
      guarded: true,
      allowed
    },
    component: () => import("@/views/auth/EscolherPerfil")
  },
  {
    name: "escolherescola",
    path: "/escolher-escola",
    meta: {
      guarded: true,
      allowed
    },
    component: () => import("@/views/auth/EscolherEscola")
  },
  {
    name: "cadastro",
    path: "/cadastro",
    meta: {
      guarded: false
    },
    component: () => import("@/views/auth/Cadastro")
  },
  {
    name: "redefinir_senha",
    path: "/redefinir-senha",
    meta: {
      guarded: false
    },
    component: () => import("@/views/auth/RedefinirSenha")
  },
  {
    name: "nova_senha",
    path: "/nova-senha/:token",
    meta: {
      guarded: false
    },
    component: () => import("@/views/auth/NovaSenha")
  },
  {
    name: "logoff",
    path: "/logoff",
    meta: {
      guarded: true,
      allowed
    },
    component: () => import("@/views/auth/Logoff")
  },
  {
    path: "/desenvolvimento",
    beforeEnter(to, from, next) {
      window.location = "http://desenvolvimento.siged.ipatinga.mg.gov.br:81";
    }
  },
  {
    path: "/treinamento",
    beforeEnter(to, from, next) {
      window.location = "http://treinamento.siged.ipatinga.mg.gov.br:82";
    }
  },
  {
    path: "/homologacao",
    beforeEnter(to, from, next) {
      window.location = "http://homologacao.siged.ipatinga.mg.gov.br:83";
    }
  }
];

export default router;
